import React from "react";
import {
	Box,
	CssBaseline,
	AppBar,
	Toolbar,
	Typography,
	Drawer,
	List,
	ListItem,
	ListItemIcon,
	ListItemText,
	IconButton,
	Grid,
	Paper,
	Avatar,
} from "@mui/material";
import {
	Menu as MenuIcon,
	Dashboard as DashboardIcon,
	Person as PersonIcon,
	Settings as SettingsIcon,
} from "@mui/icons-material";

const drawerWidth = 240;

function ADLandingUi() {
	const [mobileOpen, setMobileOpen] = React.useState(false);

	const handleDrawerToggle = () => {
		setMobileOpen(!mobileOpen);
	};

	return (
		<Box
			sx={{
				display: "flex",
				fontSize: "3rem",
				mt: "4rem",
				fontWeight: "bold",
				p: "1rem",
				textShadow:
					"1px 1px 2px #000, 2px 2px 4px #555, 3px 3px 6px #999, 4px 4px 8px #ccc",
			}}>
			Greetings and welcome to the administrators' dashboard. We hope you have a
			smooth and enjoyable experience managing your administrative tasks.
		</Box>
	);
}

export default ADLandingUi;
